import { MOKA_SERVICE_HOST } from '../../constants';

export const V1_ADVANCED_INVENTORY_CREATE_ITEMS_TRANSFER = `${MOKA_SERVICE_HOST}/reactor-stock-transfer/v1/create-item-transfer`;
export const V1_ADVANCED_INVENTORY_GET_DETAIL_ITEM_TRANSFER = (id: string) =>
  `${MOKA_SERVICE_HOST}/stock-transfer/v1/item-transfer/${id}`;
export const V1_ADVANCED_INVENTORY_UPDATE_ITEMS_TRANSFER = (id: number) =>
  `${MOKA_SERVICE_HOST}/stock-transfer/v1/item-transfer/${id}`;

export const V1_ADVANCED_INVENTORY_SUBMIT_SHIP_ITEM = `${MOKA_SERVICE_HOST}/reactor-stock-transfer/v1/ship-item-transfer`;
export const V1_ADVANCED_INVENTORY_SUBMIT_FULFILL_ITEM = `${MOKA_SERVICE_HOST}/reactor-stock-transfer/v1/fulfill-item-transfer`;
